<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18">
    <slot />
    <path
      d="M7.5 0c2.45 0 4.383 1.584 4.495 3.797L12 4v3h2c.552 0 1 .448 1 1v9c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V8c0-.552.448-1 1-1h10V4c0-1.728-1.495-3-3.5-3-1.936 0-3.396 1.186-3.495 2.823L4 4H3c0-2.319 1.975-4 4.5-4zM14 8H1v9h13V8zm-6 2c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1H7c-.552 0-1-.448-1-1v-3c0-.552.448-1 1-1h1z"
    />
  </svg>
</template>

<script>
// TODO This needs to be updated to support different colors. The original file comes in black.
export default {
  props: {
    color: String,
  },
};
</script>
